// Legacy pickers only (chat bot settings, generated content); the sales-agent pickers read the LLM registry.
export const providers = [
  { label: 'Releva', value: 'rlv' },
  { label: 'ChatGPT', value: 'chatGPT' },
  { label: 'Claude', value: 'claude' },
];

export const models = {
  rlv: [
    { label: 'Sol', value: 'sol' },
    { label: 'Luna', value: 'luna' },
    { label: 'Vega', value: 'vega' },
  ],
  chatGPT: [
    { label: 'GPT-5.4', value: 'gpt-5.4' },
    { label: 'GPT-5.4 mini', value: 'gpt-5.4-mini' },
    { label: 'GPT-5.4 nano', value: 'gpt-5.4-nano' },
  ],
  claude: [
    { label: 'Opus 5.5', value: 'claude-opus-5-5' },
    { label: 'Sonnet 5.5', value: 'claude-sonnet-5-5' },
    { label: 'Opus 5', value: 'claude-opus-5' },
    { label: 'Opus 4.8', value: 'claude-opus-4-8' },
    { label: 'Opus 4.7', value: 'claude-opus-4-7' },
    { label: 'Sonnet 5', value: 'claude-sonnet-5' },
    { label: 'Opus 4.6', value: 'claude-opus-4-6' },
    { label: 'Sonnet 4.6', value: 'claude-sonnet-4-6' },
    { label: 'Sonnet 4', value: 'claude-sonnet-4-20250514' },
    { label: 'Haiku 4.5', value: 'claude-haiku-4-5-20251001' },
  ],
};
